import { Component, OnInit } from '@angular/core';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { AppService } from '../app.service';

@Component({
  selector: 'app-listofmedications',
  templateUrl: './listofmedications.component.html',
  styleUrls: ['./listofmedications.component.scss'],
  providers: [AppService, IceNavService]
})
export class ListOfMedicationsComponent implements OnInit {

  constructor(private appSvc: AppService) {
    appSvc.defaultMenus();
    appSvc.addBreadcrumb("List of Medications", {}, true, "");
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

}
